module.exports = __webpack_public_path__ + "public/SiteImages/footerBg.svg?2d76ee49";